
import { PunkParsedGameData } from "../../../server/data/PunkParsedGameData";
import { StateSymbolWin } from "../../independent/symbol/StateSymbolWin";
import { PunkGameModuleConfig } from "../../../PunkGameModuleConfig";
import { StateHandler } from "@nolimitcity/slot-game/bin/core/utils/StateHandler";
import { SoundConfig } from "../../../SoundConfig";
import { ReelState } from "@nolimitcity/slot-game/bin/core/engines/reel/ReelEngineController";
import { SoundManager } from "../../../resource/sound/SoundManager";
import { JumpingWildController } from "../../independent/jumpingWild/JumpingWildController";
import { ReelItemOverlay } from "../../independent/overlay/ReelItemOverlay";
import { Presentation, PresentationState } from "@nolimitcity/slot-game/bin/core/gamecontroller/presentations/Presentation";
import { GameMode } from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";
import { PunkEngineManager } from "../../../punkEngine/PunkEngineManager";
import { MathHelper } from "@nolimitcity/slot-game/bin/core/utils/MathHelper";
import { ReelSymbolStates } from "@nolimitcity/slot-game/bin/core/engines/reel/symbol/ReelSpriteSymbolArea";
import { PunkSymbolData, ReelSymbolSize } from "../../../punkEngine/config/PunkSymbolData";
import { PunkSymbol } from "../../../punkEngine/PunkSymbol";
import { IExpandAnimateConfig } from "../../../punkEngine/PunkEnginePlayer";
import { IMysteryData, IAllWinData, IStickyJump } from "../../../server/data/PunkServerData";
import { ReelSlicedDivider } from "../../independent/divider/ReelSlicedDivider";

class ExpandingState extends StateHandler {
    public static readonly Expanding: string = "expanding";
    public static readonly SuperExpanding: string = "super_expanding";
    public static readonly Revealing: string = "revealing";
    public static readonly Hiding: string = "hiding";
}

export class ExpandingPresentation extends Presentation {

    protected _data: IMysteryData;
    protected _gameAreaSize: number[];
    protected _expandingDuration: number = 0.25;
    protected _revealingDuration: number = 0.35;

    protected _expanding: IExpandAnimateConfig[] = [];
    protected _expandState: ExpandingState = new ExpandingState();

    protected _noWin: boolean = false;
    protected showSymbols:boolean = false;
    protected superExpands:boolean = false;
    protected _isFreeSpin: boolean = false;
    protected _isNextNormal: boolean = false;

    protected _allHits:IAllWinData;

    protected _mysteryWinReels:number[] = [];

    protected normal:boolean = false;
    protected winReelLengt:number  = 0;
    protected possibleWinLength:number  = 0;

    protected jumpwPos:IStickyJump[] = [];

    protected _superXways:number[];
    protected _superXwayTotalValue:number;


    protected winXways:boolean  = false;

    public setParsedGamedData(data: PunkParsedGameData) {
        this._data = data.mysteryData!;
        this._allHits = data.allWinData;
        this._superXways = data.superXways;
        this._gameAreaSize = data.gameAreaSize;

        this.jumpwPos = data.stickyJumpPositions;

        this.winReelLengt = data.allWinData.longest;
        this.possibleWinLength = data.nearWinMap.length;

        this.winXways = false;

        this.normal = data.mode === GameMode.NORMAL;
        this._expanding = [];
        this.superExpands = false;
        this._noWin = data.singleWin == 0;
        this.showSymbols = data.singleWin == 0;

        this._mysteryWinReels = [];

        for (let index = 0; index < this._superXways.length; index++)
            if(this._superXways[index] != 0) this.superExpands = true;

        if(this.superExpands){
            this._superXwayTotalValue = data.gameAreaSize[0];
            const reelAmount:number = this.normal ? 5 : 6;
            for(let r:number = 1; r < reelAmount;r++){
                this._superXwayTotalValue *=  this._superXways[r] != 0 ? (this._superXways[r]+2) : data.gameAreaSize[r];
            }   
        }

        for (let reel = 0; reel < this._data.mysterySymbolPositions.length; reel++) {
            if (this._data.mysterySymbolPositions[reel] == -1) continue;

            if(!this.showSymbols){
                if(data.allWinData.reelWinPositions[reel][this._data.mysterySymbolPositions[reel]])
                    this._mysteryWinReels.push(reel);
            }

            const expandConfig: IExpandAnimateConfig = {
                toSize: ReelSymbolSize.FOUR + (this._data.mysterySymbolSize[reel] - 1),
                reelID: [reel],
                symbolID: this._data.mysterySymbolPositions[reel],
                duration: this._expandingDuration,
            }
            this._expanding.push(expandConfig);
        }
        
        let isNormal: boolean = data.mode == GameMode.NORMAL;
        this._isNextNormal = data.nextMode == GameMode.NORMAL;
        this._isFreeSpin =  !isNormal && data.mode == GameMode.FREESPIN;

        this._expandState.set(ExpandingState.Revealing);
    }

    public checkForActivation(data: PunkParsedGameData): boolean {
        return data.mysteryData != null && !!data.mysteryData!.mysterySymbolAppeared;
    }

    public getPresentation(): void {
        switch (this._expandState.state) {
            case ExpandingState.Revealing:
                this.revealing();
                this._expandState.set(ExpandingState.Hiding);
                break;
            case ExpandingState.Hiding:
                this.hideSymbols();
                this._expandState.set(PresentationState.INACTIVE);
                break;
            default:
                this.PresentationState.set(PresentationState.INACTIVE);
        }
    }

    protected hideSymbols(): void {
        if(this.winXways) SoundManager.playSoundEffect(SoundConfig.instance.XWAYS_WIN);

        PunkEngineManager.RSWindow((reel:number,symid:number) => {
            if(this._allHits.reelWinPositions[reel][symid])
                ReelItemOverlay.instance.nearWinSpot(reel,symid,0.25,true,0.1);
            else if(PunkEngineManager.getReel(reel).getSymbol(symid)!.isNormalSym){
                PunkEngineManager.getReel(reel).getSymbol(symid)!.setActive(this.showSymbols);
                ReelItemOverlay.instance.nearWinSpot(reel,symid,0.25,false);
            } 
        })
        
        this.pTimeline.to(this,this._noWin ? 0.1 : 0.35,{});
    }

    protected revealing(): void {
        const isMultiSize: boolean = !!PunkSymbolData.getSymbolConfig(this._data.mysterySymbolRevealed).MULTISIZE;
        let xpandDelay:number = 0.1;

        let expandPossibleWin:boolean = false;
        let expandSuperHit:boolean = false;

        this.pTimeline.to(this,this._revealingDuration,{},0);

        for (let j = 0; j < this._expanding.length; j++) {
            let symbol: PunkSymbol = PunkEngineManager.getReel(this._expanding[j].reelID![0]).getSymbol(this._expanding[j].symbolID!)!;
            const expandConfig: IExpandAnimateConfig = {
                toSize: this._expanding[j].toSize,
                reelID: this._expanding[j].reelID,
                symbolID: this._expanding[j].symbolID,
                updateSize: PunkSymbolData.isMultiSymbolExpanding(this._data.mysterySymbolRevealed),
                duration: 0,
            }

            if(!this.winXways) this.winXways = this._allHits.reelWinPositions[expandConfig.reelID![0]][expandConfig.symbolID!]
            if(!expandPossibleWin && this.possibleWinLength >= expandConfig.reelID![0]) expandPossibleWin = true;

            if (!isMultiSize) {
                StateSymbolWin.instance.HideMulti({
                    ReelID: expandConfig.reelID![0],
                    SymID: expandConfig.symbolID!,
                    State: ReelSymbolStates.IDLE,
                    duration: this._expandingDuration
                })
            } else{
                StateSymbolWin.instance.DropMulti({
                    ReelID: expandConfig.reelID![0],
                    SymID: expandConfig.symbolID!,
                    State: ReelSymbolStates.IDLE,
                    duration: this._expandingDuration
                })
            } 

            StateSymbolWin.instance.playFrameAnimation({
                ReelID: expandConfig.reelID![0],
                SymID: expandConfig.symbolID!,
                State: ReelSymbolStates.REVEAL,
                duration: this._revealingDuration,
            });

            if(this._superXways[expandConfig.reelID![0]] != 0){
                StateSymbolWin.instance.playSuperMultiplyAnimation({
                    value: this._superXways[expandConfig.reelID![0]].toString(),
                    symType: this._data.mysterySymbolRevealed,
                    ReelID: expandConfig.reelID![0],
                    SymID: expandConfig.symbolID!,
                    State: ReelSymbolStates.REVEAL,
                })
                if(this.possibleWinLength >= expandConfig.reelID![0]){
                    expandSuperHit = this._allHits.reelWinPositions[expandConfig.reelID![0]][expandConfig.symbolID!];
                    const timesS:number = this._superXways[expandConfig.reelID![0]] == 10 ? MathHelper.frameToSeconds(10) : MathHelper.frameToSeconds(19);
                    for(let s:number = 0; s < this._superXways[expandConfig.reelID![0]]; s++){
                        const del:number = 0.1 + timesS * (s/this._superXways[expandConfig.reelID![0]])
                        this.pTimeline.add(() => SoundManager.playSoundEffect(SoundConfig.instance.EXPANDING_PLING),xpandDelay+del);
                    }
                }
                PunkGameModuleConfig.xWayCounter.setValue(undefined, this._superXwayTotalValue, this._superXways[expandConfig.reelID![0]] == 10 ? MathHelper.frameToSeconds(10) : MathHelper.frameToSeconds(19));
            }else{
                StateSymbolWin.instance.playSymbolAnimation({
                    ReelID: expandConfig.reelID![0],
                    SymID: expandConfig.symbolID!,
                    State: ReelSymbolStates.REVEAL,
                    showSymbol: true,
                    duration: this._revealingDuration
                })
            }

            symbol.changeSymbol(this._data.mysterySymbolRevealed);
            
            PunkEngineManager.onExpandSymbol(expandConfig);

            for (let row: number = 0; row < PunkEngineManager.getReel(expandConfig.reelID![0]).AllSymbols.length; row++) {
                const smyID:number = PunkEngineManager.getReel(expandConfig.reelID![0]).AllSymbols[row].posID;
                PunkEngineManager.getReel(expandConfig.reelID![0]).getSymbol(smyID)!.playBg();
            }
            if(this._superXways[expandConfig.reelID![0]] != 0)
                symbol.showOverridedDisplayElement(StateSymbolWin.instance.getItem(expandConfig.reelID![0],expandConfig.symbolID!,ReelSymbolStates.REVEAL)!.spine!);


            if(this.jumpwPos.length > 0){
                for (let jw = 0; jw < this.jumpwPos.length; jw++){
                    if(expandConfig.reelID![0] == this.jumpwPos[jw].to.x && expandConfig.symbolID! < this.jumpwPos[jw].to.y){
                        JumpingWildController.instance.updatePosID(jw, this.jumpwPos[jw].to.x,  this.jumpwPos[jw].to.y + (PunkEngineManager.getReel(this.jumpwPos[jw].to.x).windowAmount-3)  );
                    }
                }
            }
            ReelSlicedDivider.instance.addDividers(false,expandConfig.reelID![0]);

            // PunkEngineManager.getReel(expandConfig.reelID![0]).addDividers(false);
        }

        if(this.winXways){
            SoundManager.playSoundEffect(expandSuperHit ? SoundConfig.instance.XWAYS_EXPAND_WIN_SUPER : SoundConfig.instance.XWAYS_EXPAND_WIN);
            this.pTimeline.to(this,SoundConfig.instance.XWAYS_WIN_DELAY,{});    
        }else if(expandPossibleWin){
            SoundManager.playSoundEffect(SoundConfig.instance.XWAYS_EXPAND_NO_WIN);
        }else{
            SoundManager.playSoundEffect(SoundConfig.instance.XWAYS_EXPAND_DEAD);
        }

        this._expandState.set(ExpandingState.Hiding);
    }
  
    public promiseSync(): boolean {
        return PunkEngineManager.findFirstReelWithState(ReelState.EXPAND_SYM) == -1;
    }

    public stopPresentation(): void {
        this.PresentationState.set(PresentationState.END);
        if(this.jumpwPos.length > 0){
            for (let jw = 0; jw < this.jumpwPos.length; jw++){
                JumpingWildController.instance.updateSymbolPositions(JumpingWildController.instance.getExistingItem(jw)!,0);
            }
        }
    }

    public endPresentation(): void {
        for (let j = 0; j < this._expanding.length; j++) {
            StateSymbolWin.instance.HideMulti({
                ReelID: this._expanding[j].reelID![0],
                SymID: this._expanding[j].symbolID!,
                State: ReelSymbolStates.IDLE,
            })
        }

        if(this._isNextNormal)
            PunkGameModuleConfig.xWayCounter.setValue(undefined,Math.pow(3,5),0.4);

        this.PresentationState.set(PresentationState.INACTIVE);
    }
}